import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoAdobe = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 22.5534 31.7797",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Frame",
			clipPath: "url(#clip0_136_92)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M3.02593 28.6186L2.76145 27.052C2.68601 26.6004 2.58958 25.8947 2.5161 25.4058H2.4874C2.41011 25.8984 2.30216 26.6241 2.22292 27.0558L1.93832 28.6186H3.02593ZM1.79624 29.6395L1.45251 31.3782H0.18271L1.76667 24.1447H3.32292L4.76176 31.3782H3.48532L3.1492 29.6395H1.79624Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M7.6566 28.1468C7.6566 28.0504 7.6566 27.9376 7.63746 27.8345C7.58692 27.4773 7.3969 27.1558 7.09132 27.1558C6.56714 27.1558 6.3743 27.9109 6.3743 28.7942C6.3743 29.8091 6.64921 30.3867 7.07316 30.3867C7.26699 30.3867 7.49038 30.2874 7.6117 29.8614C7.64127 29.7766 7.6566 29.663 7.6566 29.5302V28.1468ZM8.95987 23.9525V29.8778C8.95987 30.3475 8.98379 30.9252 9.00293 31.3768H7.87727L7.80378 30.7742H7.77704C7.588 31.1458 7.17655 31.4617 6.68476 31.4617C5.60683 31.4617 5.07221 30.2721 5.07221 28.7702C5.07221 26.94 5.86935 26.0499 6.73825 26.0499C7.19275 26.0499 7.48679 26.2725 7.63485 26.5944H7.65681V23.9525H8.95987Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M11.6726 30.4616C12.1701 30.4616 12.2932 29.524 12.2932 28.7478C12.2932 28.0098 12.1701 27.0482 11.6507 27.0482C11.1007 27.0482 10.9852 28.0098 10.9852 28.7478C10.9852 29.6386 11.1303 30.4616 11.6611 30.4616H11.6726ZM11.6479 31.4612C10.4467 31.4612 9.6934 30.497 9.6934 28.7708C9.6934 26.8869 10.6605 26.0496 11.6784 26.0496C12.8633 26.0496 13.6061 27.0609 13.6061 28.7403C13.6061 30.8981 12.4423 31.4612 11.6584 31.4612H11.6479Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M15.6398 29.5054C15.6398 29.6362 15.6637 29.7585 15.6915 29.8404C15.8222 30.2789 16.0437 30.3867 16.2213 30.3867C16.7255 30.3867 16.9289 29.7479 16.9289 28.7262C16.9289 27.7963 16.714 27.1558 16.2156 27.1558C15.9683 27.1558 15.7602 27.4241 15.6885 27.7124C15.6636 27.803 15.6398 27.9443 15.6398 28.0417V29.5054ZM14.3365 23.9525H15.6397V26.6831H15.6607C15.9174 26.2801 16.2593 26.0499 16.7558 26.0499C17.7383 26.0499 18.2319 27.1671 18.2319 28.628C18.2319 30.4737 17.4958 31.4617 16.5419 31.4617C16.0874 31.4617 15.7847 31.2602 15.5117 30.7495H15.4841L15.4116 31.3768H14.2926C14.3117 30.9424 14.3365 30.3475 14.3365 29.8778V23.9525Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M21.3565 28.2577C21.3633 27.5216 21.1474 27.0058 20.7339 27.0058C20.2622 27.0058 20.0617 27.6963 20.0475 28.2577H21.3565ZM20.0427 29.1792C20.058 30.1272 20.5565 30.4357 21.175 30.4357C21.5674 30.4357 21.9035 30.3486 22.1518 30.2552L22.3275 31.1928C21.9818 31.3417 21.448 31.4353 20.9363 31.4353C19.5376 31.4353 18.7736 30.4794 18.7736 28.8469C18.7736 27.0949 19.6597 26.0426 20.8168 26.0426C21.935 26.0426 22.5546 26.9726 22.5546 28.4906C22.5546 28.8381 22.5402 29.034 22.5173 29.1866L20.0427 29.1792Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M22.5544 20.2774L14.2165 0.317881H22.5544V20.2774Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M0.000504629 20.2774L8.34232 0.317881H0.000504629V20.2774Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M13.1108 20.2767L11.5226 16.2622H7.63309L11.2802 7.6729L16.5917 20.2767H13.1108Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_136_92",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22.5534,
				height: 31.7797,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogoAdobe);
export { ForwardRef as ReactComponent };
